(function () {
  'use strict';
  document.querySelectorAll('[data-ry-lesson-captions]').forEach(function (button) {
    button.addEventListener('click', function () {
      var video = button.closest('.ry-lesson-gallery__card').querySelector('video');
      var track = video && video.textTracks[0];
      if (!track) return;
      var show = track.mode !== 'showing';
      track.mode = show ? 'showing' : 'disabled';
      button.setAttribute('aria-pressed', String(show));
      button.textContent = (show ? 'Hide' : 'Show') + ' English captions (auto-generated)';
    });
  });
  document.querySelectorAll('[data-ry-lesson-play]').forEach(function (button) {
    button.addEventListener('click', function () {
      var id = button.getAttribute('data-ry-lesson-play');
      if (!/^[A-Za-z0-9_-]{11}$/.test(id || '')) return;
      var frame = document.createElement('iframe');
      frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?rel=0&playsinline=1';
      frame.title = button.getAttribute('data-ry-lesson-title') || 'Rainbow Yoga lesson extract';
      frame.allow = 'encrypted-media; picture-in-picture; fullscreen';
      frame.allowFullscreen = true;
      frame.referrerPolicy = 'strict-origin-when-cross-origin';
      frame.tabIndex = 0;
      button.parentElement.replaceChildren(frame);
      frame.focus();
    }, { once: true });
  });
}());
